module.exports = __webpack_public_path__ + "static/media/img002.3b052951.jpg";